import { useState } from 'react'
import { avatarColour } from './avatarColor'

const SIZE_CLASSES = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-16 w-16 text-xl',
}

function getInitials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('')
}

interface Props {
  userId: string | null
  name: string
  avatarExt: string | null
  avatarUpdatedAt: string | null
  /** Pre-built avatar URL — when provided, overrides the URL constructed from avatarExt/avatarUpdatedAt */
  avatarUrl?: string | null
  size?: 'sm' | 'md' | 'lg'
  /** Kept for callers; avatars now take a colour per person instead. */
  primaryColor?: string | null
}

export function MemberAvatar({
  userId,
  name,
  avatarExt,
  avatarUpdatedAt,
  avatarUrl,
  size = 'sm',
}: Props) {
  const apiUrl = import.meta.env.VITE_API_URL as string
  const [imgError, setImgError] = useState(false)

  const sizeClass = SIZE_CLASSES[size]

  const resolvedSrc = avatarUrl
    ? avatarUrl
    : userId && avatarExt
      ? `${apiUrl}/member-avatar/${encodeURIComponent(userId)}${avatarUpdatedAt ? `?v=${new Date(avatarUpdatedAt).getTime()}` : ''}`
      : null

  if (resolvedSrc && !imgError) {
    return (
      <img
        src={resolvedSrc}
        alt={name}
        className={`${sizeClass} shrink-0 rounded-full object-cover`}
        onError={() => setImgError(true)}
      />
    )
  }

  return (
    <div
      className={`${sizeClass} flex shrink-0 items-center justify-center rounded-full font-bold text-white`}
      style={{ backgroundColor: avatarColour(name || userId || '?') }}
    >
      {getInitials(name) || '?'}
    </div>
  )
}
